import { getWindowInfo } from "@tarojs/taro";
import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { useMemo } from "react";
import { prefixClassname } from "../styles/index.js";
function SafeArea(props) {
    const { className, position, nativeSafeTop, style, ...restProps } = props;
    const { statusBarHeight } = getWindowInfo();
    const customStyle = useMemo(() => {
        if (position === "top" && nativeSafeTop) {
            return {
                paddingTop: `${statusBarHeight || 0}px`,
            };
        }
        return {};
    }, [position, nativeSafeTop, statusBarHeight]);
    return (React.createElement(View, { className: classNames(prefixClassname("safe-area"), {
            [prefixClassname("safe-area--top")]: position === "top",
            [prefixClassname("safe-area--bottom")]: position === "bottom",
        }, className), style: {
            ...customStyle,
            ...style,
        }, ...restProps }));
}
export default SafeArea;
